import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { SilobagTagListPayload, SilobagTagListResponse } from './silobag-tag-list.types';

export async function silobagTagListService({ query: rawQuery }: SilobagTagListPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.get<SilobagTagListResponse>(ENDPOINT.SILOBAG_TAGS, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
